const DEFAULT_AVATAR = "AA";

const generateAvatarInitials = (fistname, lastname) => {
  let initials = "";
  if (fistname) {
    initials += fistname[0].toUpperCase();
  }
  if (lastname) {
    initials += lastname[0].toUpperCase();
  }

  if (initials === "") {
    return DEFAULT_AVATAR;
  }

  return initials;
};

export default { generateAvatarInitials };
